export const BACK = "Volver";
export const NEXT = "Siguiente";
export const CONFIRM = "Confirmar";
export const FINALIZE = "Finalizar";
